import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCondominio } from '../contexts/CondominioContext';
import { Plus, Edit, Trash2, Car, Search, Filter } from 'lucide-react';

const Veiculos = () => {
  const { user } = useAuth();
  const { condominioSelecionado, getCondominioId } = useCondominio();
  const [veiculos, setVeiculos] = useState([]);
  const [apartamentos, setApartamentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingVeiculo, setEditingVeiculo] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filters, setFilters] = useState({
    status: '',
    tipo: '',
    placa: '',
    apartamento_id: ''
  });
  const [formData, setFormData] = useState({
    veiculo_placa: '',
    veiculo_modelo: '',
    veiculo_marca: '',
    veiculo_cor: '',
    veiculo_ano: '',
    veiculo_tipo: 'carro',
    veiculo_status: 'ativo',
    apartamento_id: '',
    veiculo_observacoes: ''
  });

  useEffect(() => {
    if (condominioSelecionado) {
      loadVeiculos();
      loadApartamentos();
    }
  }, [condominioSelecionado]);

  const loadVeiculos = async () => {
    try {
      setLoading(true);
      const condominioId = getCondominioId();
      if (!condominioId) return;

      const params = new URLSearchParams();
      params.append('condominio_id', condominioId);
      
      if (filters.status) params.append('status', filters.status);
      if (filters.tipo) params.append('tipo', filters.tipo);
      if (filters.placa) params.append('placa', filters.placa);
      if (filters.apartamento_id) params.append('apartamento_id', filters.apartamento_id);

      const response = await fetch(`http://localhost:5000/api/veiculos?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setVeiculos(data.data.veiculos);
      }
    } catch (error) {
      console.error('Erro ao carregar veículos:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadApartamentos = async () => {
    try {
      const condominioId = getCondominioId();
      if (!condominioId) return;

      const response = await fetch(`http://localhost:5000/api/apartamentos?condominio_id=${condominioId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setApartamentos(data.data.apartamentos);
      }
    } catch (error) {
      console.error('Erro ao carregar apartamentos:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');

    try {
      const condominioId = getCondominioId();
      const dadosParaEnvio = {
        ...formData,
        condominio_id: condominioId,
        apartamento_id: formData.apartamento_id || null,
        veiculo_ano: formData.veiculo_ano || null
      };

      const url = editingVeiculo 
        ? `http://localhost:5000/api/veiculos/${editingVeiculo.veiculo_id}`
        : 'http://localhost:5000/api/veiculos';
      
      const method = editingVeiculo ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(dadosParaEnvio)
      });

      const result = await response.json();

      if (result.success) {
        setShowModal(false);
        resetForm();
        loadVeiculos();
      } else {
        setErrorMessage(result.message || 'Erro ao salvar veículo');
      }
    } catch (error) {
      setErrorMessage('Erro ao salvar veículo');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (veiculo) => {
    setEditingVeiculo(veiculo);
    setFormData({
      veiculo_placa: veiculo.veiculo_placa,
      veiculo_modelo: veiculo.veiculo_modelo,
      veiculo_marca: veiculo.veiculo_marca,
      veiculo_cor: veiculo.veiculo_cor,
      veiculo_ano: veiculo.veiculo_ano || '',
      veiculo_tipo: veiculo.veiculo_tipo,
      veiculo_status: veiculo.veiculo_status,
      apartamento_id: veiculo.apartamento_id || '',
      veiculo_observacoes: veiculo.veiculo_observacoes || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este veículo?')) return;

    try {
      const response = await fetch(`http://localhost:5000/api/veiculos/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const result = await response.json();

      if (result.success) {
        loadVeiculos();
      } else {
        alert('Erro ao excluir veículo: ' + result.message);
      }
    } catch (error) {
      alert('Erro ao excluir veículo');
    }
  };

  const resetForm = () => {
    setFormData({
      veiculo_placa: '',
      veiculo_modelo: '',
      veiculo_marca: '',
      veiculo_cor: '',
      veiculo_ano: '',
      veiculo_tipo: 'carro',
      veiculo_status: 'ativo',
      apartamento_id: '',
      veiculo_observacoes: ''
    });
    setEditingVeiculo(null);
    setErrorMessage('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    loadVeiculos();
  };

  const clearFilters = () => {
    setFilters({
      status: '',
      tipo: '',
      placa: '',
      apartamento_id: ''
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'ativo': 'bg-green-100 text-green-800',
      'inativo': 'bg-gray-100 text-gray-800',
      'bloqueado': 'bg-red-100 text-red-800'
    };
    return statusMap[status] || 'bg-gray-100 text-gray-800';
  };

  const getTipoBadge = (tipo) => {
    const tipoMap = {
      'carro': 'bg-blue-100 text-blue-800',
      'moto': 'bg-yellow-100 text-yellow-800',
      'caminhao': 'bg-purple-100 text-purple-800',
      'van': 'bg-green-100 text-green-800',
      'outros': 'bg-gray-100 text-gray-800'
    };
    return tipoMap[tipo] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <Car className="h-8 w-8 text-blue-600" />
          <h1 className="text-2xl font-bold text-gray-900">Veículos</h1>
        </div>
        <button
          onClick={() => {
            resetForm();
            setShowModal(true);
          }}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
        >
          <Plus className="h-4 w-4" />
          Novo Veículo
        </button>
      </div>

      {/* Filtros */}
      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
            <select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2"
            >
              <option value="">Todos</option>
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
              <option value="bloqueado">Bloqueado</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
            <select
              name="tipo"
              value={filters.tipo}
              onChange={handleFilterChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2"
            >
              <option value="">Todos</option>
              <option value="carro">Carro</option>
              <option value="moto">Moto</option>
              <option value="caminhao">Caminhão</option>
              <option value="van">Van</option>
              <option value="outros">Outros</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Placa</label>
            <input
              type="text"
              name="placa"
              value={filters.placa}
              onChange={handleFilterChange}
              placeholder="Buscar por placa"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Apartamento</label>
            <select
              name="apartamento_id"
              value={filters.apartamento_id}
              onChange={handleFilterChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2"
            >
              <option value="">Todos</option>
              {apartamentos.map(apt => (
                <option key={apt.apartamento_id} value={apt.apartamento_id}>
                  {apt.apartamento_bloco} - {apt.apartamento_numero}
                </option>
              ))}
            </select>
          </div>
          <div className="flex items-end gap-2">
            <button
              onClick={applyFilters}
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center gap-2"
            >
              <Search className="h-4 w-4" />
              Filtrar
            </button>
            <button
              onClick={clearFilters}
              className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600"
            >
              Limpar
            </button>
          </div>
        </div>
      </div>

      {/* Tabela */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Placa
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Veículo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Apartamento
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                    Carregando...
                  </td>
                </tr>
              ) : veiculos.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                    Nenhum veículo encontrado
                  </td>
                </tr>
              ) : (
                veiculos.map((veiculo) => (
                  <tr key={veiculo.veiculo_id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {veiculo.veiculo_placa}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      <div>
                        <div className="font-medium">{veiculo.veiculo_marca} {veiculo.veiculo_modelo}</div>
                        <div className="text-gray-500">{veiculo.veiculo_cor}</div>
                        {veiculo.veiculo_ano && (
                          <div className="text-gray-500">{veiculo.veiculo_ano}</div>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getTipoBadge(veiculo.veiculo_tipo)}`}>
                        {veiculo.veiculo_tipo}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {veiculo.apartamento ? 
                        `${veiculo.apartamento.apartamento_bloco} - ${veiculo.apartamento.apartamento_numero}` : 
                        'N/A'
                      }
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadge(veiculo.veiculo_status)}`}>
                        {veiculo.veiculo_status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleEdit(veiculo)}
                          className="text-blue-600 hover:text-blue-900"
                        >
                          <Edit className="h-4 w-4" />
                        </button>
                        <button
                          onClick={() => handleDelete(veiculo.veiculo_id)}
                          className="text-red-600 hover:text-red-900"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-10 mx-auto p-5 border w-11/12 md:w-4/5 lg:w-3/4 xl:w-2/3 shadow-lg rounded-md bg-white max-h-[90vh] overflow-y-auto veiculos-modal">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {editingVeiculo ? 'Editar Veículo' : 'Novo Veículo'}
              </h2>
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditingVeiculo(null);
                  resetForm();
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            </div>
            
            {errorMessage && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {errorMessage}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Placa *
                  </label>
                  <input
                    type="text"
                    name="veiculo_placa"
                    value={formData.veiculo_placa}
                    onChange={handleInputChange}
                    required
                    maxLength="8"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    placeholder="ABC1234 ou ABC1D23"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tipo *
                  </label>
                  <select
                    name="veiculo_tipo"
                    value={formData.veiculo_tipo}
                    onChange={handleInputChange}
                    required
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  >
                    <option value="carro">Carro</option>
                    <option value="moto">Moto</option>
                    <option value="caminhao">Caminhão</option>
                    <option value="van">Van</option>
                    <option value="outros">Outros</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Marca *
                  </label>
                  <input
                    type="text"
                    name="veiculo_marca"
                    value={formData.veiculo_marca}
                    onChange={handleInputChange}
                    required
                    maxLength="30"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Modelo *
                  </label>
                  <input
                    type="text"
                    name="veiculo_modelo"
                    value={formData.veiculo_modelo}
                    onChange={handleInputChange}
                    required
                    maxLength="50"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Cor *
                  </label>
                  <input
                    type="text"
                    name="veiculo_cor"
                    value={formData.veiculo_cor}
                    onChange={handleInputChange}
                    required
                    maxLength="20"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Ano
                  </label>
                  <input
                    type="number"
                    name="veiculo_ano"
                    value={formData.veiculo_ano}
                    onChange={handleInputChange}
                    min="1900"
                    max={new Date().getFullYear() + 1}
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Apartamento *
                  </label>
                  <select
                    name="apartamento_id"
                    value={formData.apartamento_id}
                    onChange={handleInputChange}
                    required
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  >
                    <option value="">Selecione um apartamento</option>
                    {apartamentos.map(apt => (
                      <option key={apt.apartamento_id} value={apt.apartamento_id}>
                        {apt.apartamento_bloco} - {apt.apartamento_numero}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status *
                  </label>
                  <select
                    name="veiculo_status"
                    value={formData.veiculo_status}
                    onChange={handleInputChange}
                    required
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  >
                    <option value="ativo">Ativo</option>
                    <option value="inativo">Inativo</option>
                    <option value="bloqueado">Bloqueado</option>
                  </select>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Observações
                </label>
                <textarea
                  name="veiculo_observacoes"
                  value={formData.veiculo_observacoes}
                  onChange={handleInputChange}
                  maxLength="500"
                  rows="3"
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                />
              </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(false);
                    resetForm();
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                >
                  {isSubmitting ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Veiculos;

// Estilos CSS personalizados para o modal de Veículos
const veiculosStyles = `
  .veiculos-modal .input-field {
    width: 100%;
    padding: 0.75rem;
    border: 2px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    transition: all 0.2s ease-in-out;
    background-color: #f9fafb;
  }
  
  .veiculos-modal .input-field:focus {
    outline: none;
    border-color: #3b82f6;
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  .veiculos-modal .input-field:hover {
    border-color: #d1d5db;
    background-color: #ffffff;
  }
  
  .veiculos-modal .btn-primary {
    background-color: #3b82f6;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    border: none;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
  }
  
  .veiculos-modal .btn-primary:hover:not(:disabled) {
    background-color: #2563eb;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }
  
  .veiculos-modal .btn-primary:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
  
  .veiculos-modal .btn-secondary {
    background-color: #6b7280;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    border: none;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
  }
  
  .veiculos-modal .btn-secondary:hover {
    background-color: #4b5563;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(107, 114, 128, 0.3);
  }
`;

// Adicionar estilos ao documento
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = veiculosStyles;
  document.head.appendChild(styleSheet);
}
